'use client'

import { useState, useEffect } from 'react'
import { AlertCircle, Wifi, WifiOff, RefreshCw } from 'lucide-react'

export default function BackendHealthMonitor() {
  const [backendStatus, setBackendStatus] = useState({
    isOnline: true,
    lastCheck: null,
    consecutiveFailures: 0,
    lastError: null
  })
  const [showNotification, setShowNotification] = useState(false)
  const [isRetrying, setIsRetrying] = useState(false)

  useEffect(() => {
    // Service Worker Registration DISABLED - Not needed
    // const isLocalhost = typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
    // if ('serviceWorker' in navigator && isLocalhost) {
    //   navigator.serviceWorker.register('/sw-backend-health.js')
    //     .then(registration => {
    //       // console.log('🔧 Backend Health SW registered:', registration)
    //     })
    //     .catch(error => {
    //       console.error('❌ Backend Health SW registration failed:', error)
    //     })
    //
    //   // Listen for messages from Service Worker
    //   navigator.serviceWorker.addEventListener('message', handleServiceWorkerMessage)
    // }
    //
    // return () => {
    //   if ('serviceWorker' in navigator && isLocalhost) {
    //     navigator.serviceWorker.removeEventListener('message', handleServiceWorkerMessage)
    //   }
    // }
  }, [])

  const handleServiceWorkerMessage = (event) => {
    if (event.data.type === 'BACKEND_STATUS') {
      const isOnline = event.data.status === 'online'
      
      setBackendStatus({
        isOnline,
        lastCheck: event.data.timestamp,
        consecutiveFailures: event.data.consecutiveFailures || 0,
        lastError: event.data.error || null
      })

      // Show notification when status changes
      if (!isOnline && backendStatus.isOnline) {
        setShowNotification(true)
        setTimeout(() => setShowNotification(false), 8000) // Hide after 8s
      } else if (isOnline && !backendStatus.isOnline) {
        setShowNotification(true)
        setTimeout(() => setShowNotification(false), 3000) // Hide after 3s
      }
    }
  }

  const forceHealthCheck = async () => {
    setIsRetrying(true)
    
    if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({
        type: 'FORCE_HEALTH_CHECK'
      })
    }
    
    setTimeout(() => setIsRetrying(false), 2000)
  }

  // Don't render anything if backend is online and no notification is needed
  if (backendStatus.isOnline && !showNotification) {
    return null
  }

  return (
    <>
      {/* Status Badge (always visible when offline) */}
      {!backendStatus.isOnline && (
        <div className="fixed top-4 right-4 z-50">
          <div className="bg-red-500 text-white px-3 py-2 rounded-lg shadow-lg flex items-center gap-2">
            <WifiOff size={16} />
            <span className="text-sm font-medium">Backend Offline</span>
            <button
              onClick={forceHealthCheck}
              disabled={isRetrying}
              className="ml-2 p-1 hover:bg-red-600 rounded transition-colors"
            >
              <RefreshCw size={14} className={isRetrying ? 'animate-spin' : ''} />
            </button>
          </div>
        </div>
      )}

      {/* Notification Toast */}
      {showNotification && (
        <div className={`fixed top-4 left-1/2 transform -translate-x-1/2 z-50 transition-all duration-300 ${
          showNotification ? 'translate-y-0 opacity-100' : '-translate-y-4 opacity-0'
        }`}>
          <div className={`px-4 py-3 rounded-lg shadow-xl flex items-center gap-3 ${
            backendStatus.isOnline 
              ? 'bg-green-500 text-white'
              : 'bg-red-500 text-white'
          }`}>
            {backendStatus.isOnline ? (
              <>
                <Wifi size={20} />
                <div>
                  <div className="font-medium">Backend ist wieder online</div>
                  <div className="text-sm opacity-90">Alle Funktionen verfügbar</div>
                </div>
              </>
            ) : (
              <>
                <AlertCircle size={20} />
                <div>
                  <div className="font-medium">Backend ist offline</div>
                  <div className="text-sm opacity-90">
                    {backendStatus.lastError || 'Verbindung fehlgeschlagen'}
                  </div>
                </div>
              </>
            )}
            <button
              onClick={() => setShowNotification(false)}
              className="ml-2 p-1 hover:bg-white hover:bg-opacity-20 rounded transition-colors"
            >
              ×
            </button>
          </div>
        </div>
      )}

      {/* Developer Debug Info (only in development) */}
      {process.env.NODE_ENV === 'development' && !backendStatus.isOnline && (
        <div className="fixed bottom-4 right-4 bg-gray-900 text-white p-3 rounded-lg text-xs z-40">
          <div className="font-medium mb-1">Backend Debug Info:</div>
          <div>Failures: {backendStatus.consecutiveFailures}</div>
          <div>Last Check: {backendStatus.lastCheck ? new Date(backendStatus.lastCheck).toLocaleTimeString() : 'Never'}</div>
          <div>Error: {backendStatus.lastError || 'None'}</div>
          <button
            onClick={forceHealthCheck}
            className="mt-2 bg-blue-600 hover:bg-blue-700 px-2 py-1 rounded text-xs"
          >
            Force Check
          </button>
        </div>
      )}
    </>
  )
} 